import { ICategoryMeta } from '@/interfaces/categoryPage';
import { Typography } from '@pwskills/rachnaui';
import React from 'react';

const CategoryStatistics = ({
  categoryStatistics,
}: {
  categoryStatistics: ICategoryMeta[] | undefined;
}) => {
  if (!categoryStatistics) {
    return null;
  }

  // const { careerTransition, highestSalary, hiringPartner, salaryHike } = categoryStatistics;
  // const categoryPageStatistics = [
  //   {
  //     id: 1,
  //     imgLink: '/images/categoryPage/Growth.svg',
  //     subTitle: `${salaryHike}`,
  //     title: 'Average Salary Hike',
  //   },
  //   {
  //     id: 2,
  //     imgLink: '/images/categoryPage/Money.svg',
  //     subTitle: `${highestSalary}`,
  //     title: 'Highest Salary',
  //   },
  //   {
  //     id: 3,
  //     imgLink: '/images/categoryPage/UpDownArrow.svg',
  //     subTitle: `${careerTransition}`,
  //     title: 'Career Transitions',
  //   },
  //   {
  //     id: 4,
  //     imgLink: '/images/categoryPage/Work.svg',
  //     subTitle: `${hiringPartner}`,
  //     title: 'Hiring Partners',
  //   },
  // ];
  const filteredCategoryStatistics = categoryStatistics
    .filter((stat) => stat.title || stat.subText)
    .slice(0, 4);
  return (
    <div className="flex flex-row items-center justify-center large:!justify-between gap-y-[24px] flex-wrap gap-x-4 medium:!gap-x-6 w-full large:!w-fit mx-auto">
      {filteredCategoryStatistics.length > 0 &&
        filteredCategoryStatistics?.map((item, index) =>
          item.title ? (
            <div
              key={item?._id}
              className="flex items-center justify-center medium:!justify-start gap-x-4 w-[45%] medium:!w-fit h-[62px] !m-0 large:!self-start"
            >
              <div className="w-full medium:!w-fit gap-2 medium:max-w-[180px]">
                <Typography
                  component="h4"
                  variant="bold"
                  className="text-white !text-[18px] medium:!leading-[18px] large:!text-[24px] large:!leading-9 line-clamp-1 break-words"
                >
                  {item.title.length > 12 ? `${item.title.slice(0, 9)}...` : item.title}
                </Typography>
                <Typography
                  component="body-regular"
                  variant="regular"
                  className="text-[#E4E7EA] text-[12px] !leading-[26px] font-semibold line-clamp-1 break-words"
                >
                  {item.subText.length > 20 ? `${item.subText.slice(0, 17)}...` : item.subText}
                </Typography>
              </div>
              <div
                className={`w-[1px] h-[62px] ${index % 2 !== 0 ? 'hidden medium:!flex' : 'flex'} ${
                  index === Object.keys(filteredCategoryStatistics).length - 1
                    ? 'hidden medium:!hidden'
                    : ''
                } !m-0`}
                style={{
                  background:
                    'linear-gradient(99deg, rgba(255, 255, 255, 0.20) 6.34%, #908D8D 30.92%, rgba(255, 255, 255, 0.20) 72.59%)',
                }}
              />
            </div>
          ) : null
        )}
    </div>
  );
};

export default CategoryStatistics;
